"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const NODE_TYPES = {
    read: () => true,
    search: () => true,
    write: () => true,
    search_or_write: () => true,
    filter: (crumb, crumbs) => {
        const index = crumbs.indexOf(crumb);
        const nextCrumb = crumbs[index + 1] || { object_id: undefined };
        return crumb.object_id !== nextCrumb.object_id;
    },
};
const getNodeCrumbs = (taskState) => {
    return lodash_1.filter(taskState.breadcrumbs, crumb => crumb.object_type &&
        lodash_1.isFunction(NODE_TYPES[crumb.object_type]) &&
        NODE_TYPES[crumb.object_type](crumb, taskState.breadcrumbs));
};
exports.default = getNodeCrumbs;
